var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcCheckCircle = function SvgIcCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m4.27 8.33-4.75 4.75a1 1 0 0 1-1.41 0l-2.38-2.37a1.003 1.003 0 1 1 1.42-1.42L10.81 13l4-4a1 1 0 0 1 1.42 0 1 1 0 0 1 .04 1.33"
  })));
};
export default SvgIcCheckCircle;